var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 5.4C10.6021 5.39469 9.11555 6.0052 8.01817 7.09695C6.92079 8.1887 6.30265 9.67205 6.3 11.22V17.1C6.3 17.3387 6.39482 17.5676 6.5636 17.7364C6.73239 17.9052 6.96131 18 7.2 18H9.3C9.79706 18 10.2 17.5971 10.2 17.1V11.22C10.1996 10.6687 10.4338 10.1432 10.8441 9.77494C11.2543 9.40665 11.8019 9.23032 12.35 9.29C13.356 9.41671 14.1079 10.2761 14.1 11.29V17.1C14.1 17.5971 14.5029 18 15 18H17.1C17.5971 18 18 17.5971 18 17.1V11.22C17.9974 9.67205 17.3792 8.1887 16.2818 7.09695C15.1845 6.0052 13.6979 5.39469 12.15 5.4Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.2C0 6.70294 0.402944 6.3 0.9 6.3H3.6C4.09706 6.3 4.5 6.70294 4.5 7.2V17.1C4.5 17.5971 4.09706 18 3.6 18H0.9C0.402944 18 0 17.5971 0 17.1V7.2Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.25C4.5 3.49264 3.49264 4.5 2.25 4.5C1.00736 4.5 0 3.49264 0 2.25C0 1.00736 1.00736 0 2.25 0C3.49264 0 4.5 1.00736 4.5 2.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.4970e365313dc460ae0173b60fc19743.svg";
export { ForwardRef as ReactComponent };